import * as React from "react";

import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import SensorsOutlinedIcon from "@mui/icons-material/SensorsOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";

import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import SyncAltOutlinedIcon from "@mui/icons-material/SyncAltOutlined";

import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";

import { ROUTES } from "../shared/constants/routes";

export const fludeeNavGroups = [
  {
    type: "item",
    key: "hospital-form",
    label: "Hospital Form",
    path: ROUTES.OVERVIEW,
    icon: <AccessTimeOutlinedIcon />,
  },
  {
    type: "item",
    key: "org-profile",
    label: "Organization Profile",
    path: ROUTES.COREE_LISTS,
    icon: <ApartmentOutlinedIcon />,
  },
  {
    type: "item",
    key: "patients-form",
    label: "Patients Form",
    path: ROUTES.STAFF_DETAILS,
    icon: <GroupsOutlinedIcon />,
  },
  {
    type: "item",
    key: "admission-form",
    label: "Admission Form",
    path: ROUTES.ADMISSIONS_CREATE,
    icon: <GroupsOutlinedIcon />,
  },
  {
    type: "item",
    key: "Patients-Profile",
    label: "Patients-Profile",
    path: ROUTES.ADMISSIONS_LIST,
    icon: <GroupsOutlinedIcon />,
  },
  // Fludee Device Group
  {
    type: "group",
    key: "fludee-device",
    label: "Fludee Device",
    icon: <GroupsOutlinedIcon />,
    children: [
      {
        key: "fludee-device id",
        label: "fludee-device id",
        path: ROUTES.DEVICE_CREATE,
        icon: <SensorsOutlinedIcon />,
      },

      {
        key: "fludee-device-sensor-channel",
        label: "Sensor Channel",
        path: ROUTES.SENSOR_CHANNELS_CREATE,
        icon: <SensorsOutlinedIcon />,
      },
      {
        key: "DEVICE_ASSIGNMENT",
        label: "DEVICE_ASSIGNMENT",
        path: ROUTES.DEVICE_ASSIGNMENT_CREATE,
        icon: <ListAltOutlinedIcon />,
      },

      {
        key: "Device Assignment List",
        label: "Device Assignment List",
        path: ROUTES.DEVICE_ASSIGNMENT_LIST,
        icon: <ListAltOutlinedIcon />,
      },
      // {
      //   key: "fludee-device-alarms",
      //   label: "Alarms",
      //   path: ROUTES.MONITORING_ALARMS,
      //   icon: <NotificationsActiveOutlinedIcon />,
      // },
      // {
      //   key: "fludee-device-history",
      //   label: "History",
      //   path: ROUTES.MONITORING_HISTORY,
      //   icon: <HistoryOutlinedIcon />,
      // },
    ],
  },

  // Monitoring Group
  {
    type: "group",
    key: "monitoring",
    label: "Monitoring",
    icon: <MonitorHeartOutlinedIcon />,
    children: [
      
      // {
      //   key: "Drip-sessions",
      //   label: "Drip-sessions",
      //   path: ROUTES.drip_sessions,
      //   icon: <ListAltOutlinedIcon />,
      // },
      {
        key: "monitoring-live",
        label: "Live",
        path: ROUTES.Fludee_Front_Live,
        icon: <SensorsOutlinedIcon />,
      },
      // {
      //   key: "monitoring-sessions",
      //   label: "Sessions",
      //   path: ROUTES.MONITORING_SESSIONS,
      //   icon: <ListAltOutlinedIcon />,
      // },
      // {
      //   key: "monitoring-alarms",
      //   label: "Alarms",
      //   path: ROUTES.MONITORING_ALARMS,
      //   icon: <NotificationsActiveOutlinedIcon />,
      // },
      // {
      //   key: "monitoring-history",
      //   label: "History",
      //   path: ROUTES.MONITORING_HISTORY,
      //   icon: <HistoryOutlinedIcon />,
      // },
    ],
  },

  // Vitals Group
  {
    type: "group",
    key: "vitals",
    label: "Vitals",
    icon: <ShowChartOutlinedIcon />,
    children: [
      {
        key: "vitals-streaming",
        label: "Streaming",
        path: ROUTES.VITALS_STREAMING,
        icon: <ShowChartOutlinedIcon />,
      },
      // {
      //   key: "vitals-rules",
      //   label: "Rules",
      //   path: ROUTES.VITALS_RULES,
      //   icon: <RuleOutlinedIcon />,
      // },
      // {
      //   key: "vitals-history",
      //   label: "History",
      //   path: ROUTES.VITALS_HISTORY,
      //   icon: <HistoryOutlinedIcon />,
      // },
    ],
  },

  // Balance Group
  // {
  //   type: "group",
  //   key: "balance",
  //   label: "Balance",
  //   icon: <AccountBalanceWalletOutlinedIcon />,
  //   children: [
  //     {
  //       key: "fludee-balance",
  //       label: "Fludee Balance",
  //       path: ROUTES.FLUDEE_BALANCE,
  //       icon: <AccountBalanceWalletOutlinedIcon />,
  //     },
  //     {
  //       key: "intake-output",
  //       label: "Intake / Output",
  //       path: ROUTES.INTAKE_OUTPUT,
  //       icon: <SyncAltOutlinedIcon />,
  //     },
  //   ],
  // },

  // Medicine Group
  {
    type: "group",
    key: "medicine",
    label: "Medicine",
    icon: <MedicationOutlinedIcon />,
    children: [

      {
        key: "Clinical Overview",
        label: "Clinical Overview",
        path: ROUTES.PatientClinicalOverviewDashboard,
         icon: <EventNoteOutlinedIcon />,
      },
      {
        key: "Fluid Therapy-chart",
        label: "Fluid Therapy-chart",
        path: ROUTES.FluidTherapy,
        icon: <MedicationOutlinedIcon />,
      },
      // {
      //   key: "Fluid therapy history",
      //   label: "fluid therapy history",
      //   path: ROUTES.fluid_therapy_history,
      //   icon: <EventNoteOutlinedIcon />,
      // },

      {
         key: "Medication Chart",
          label: "Medication Chart",
        path: ROUTES.MEDICATION_CHART,
      },
      // {
      //    key: "Medication  History",
      //   label: "Medication History",
      //   path: ROUTES.MEDICATION_SUMMARY,
      // },
      {
         key: "Investigation Chart",
        label: "Investigation Chart",
        path: ROUTES.INVESTIGATION_CREATE,
      },
      // {
      //    key: "INVESTIGATION HISTORY",
      //   label: "INVESTIGATION HISTORY",
      //   path: ROUTES.INVESTIGATION_HISTORY,
      // }
    ],
    
  },
  {
    type: "item",
    key: "Up coming live dashboard ",
    label: "Up coming live dashboard",
    path: ROUTES.MONITORING_LIVE,
    icon: <AccessTimeOutlinedIcon />,
  },
];